import React, { useState } from "react"
import { createBrowserHistory } from "history"
import { motion } from "framer-motion"
import Header from "../Components/Header"
import StudentSdebar from "./StudentSdebar"
import AchievementsCards from "../Components/AchievementsCards"

// --- Images ---
import Sftm from "../Images/student_of_the_month.jpg"
import kudos from "../Images/Kudos.jpg"
import levelup from "../Images/Level_up.jpg"

const history = createBrowserHistory()

const Achievements = () => {
  const [sidebarExpanded, setSidebarExpanded] = useState(true)

  const handleNavigation = (path) => {
    history.push(path)
  }

  const scrollStyles = {
    scrollbarWidth: "thin",
    scrollbarColor: "#B8529E #f0f0f5",
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f4f4f9",
        overflow: "hidden",
      }}
    >
      <Header />

      <div
        style={{
          display: "flex",
          marginTop: "60px", // same height as header
          height: "calc(100vh - 60px)",
        }}
      >
        <StudentSdebar onToggle={setSidebarExpanded} />

        <motion.div
          className="main-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          style={{
            flexGrow: 1,
            marginLeft: sidebarExpanded ? "240px" : "60px",
            width: sidebarExpanded ? "calc(100% - 240px)" : "calc(100% - 60px)",
            overflowY: "auto",
            scrollBehavior: "smooth",
            padding: "30px",
            ...scrollStyles,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              borderRadius: "10px",
              padding: "25px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              minHeight: "85vh",
            }}
          >
            <div
              className="text-center border rounded text-light mb-4 p-1 mx-auto"
              style={{
                background:
                  "linear-gradient(to right, #3953A3, #7D52A0, #8852A0, #B8529E)",
                width: "80%",
                maxWidth: "300px",
              }}
            >
              <h1 style={{ fontSize: "24px" }}>My Achievements</h1>
            </div>

            <div
              className="achievement-cards-container"
              style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                gap: "25px",
                width: "100%",
              }}
            >
              <AchievementsCards
                img={Sftm}
                title="Student of the Month"
                date="18th Sept 2024"
              />
              <AchievementsCards
                img={kudos}
                title="Kudos!!"
                date="25th Sept 2024"
              />
              <AchievementsCards
                img={levelup}
                title="Level Up"
                date="7th Oct 2024"
              />
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  )
}

export default Achievements
